import * as React from 'react';
const Image = React.forwardRef(({ alt = '', ...props }, ref) => {
    return React.createElement("img", { ref: ref, alt: alt, role: alt ? undefined : 'presentation', ...props });
});
Image.displayName = 'Image';
export default Image;
